/**
 * PAEX nav analytics — GA4-style navigation events from the approved Seasonal
 * Nav prototype: nav_open (a menu panel/drawer opened), nav_click (a nav link
 * or control clicked), nav_abandon (a panel opened, then closed with no click
 * inside, after a dwell threshold to filter hover-open noise). Pushed to
 * window.dataLayer (created if absent); gtag is optional. Loaded (deferred)
 * by sections/header.liquid when the "Nav analytics" theme setting is on.
 *
 * Listeners are document-capture and purely passive toward the theme:
 * `toggle` doesn't bubble but IS observable in capture phase; the capture
 * click listener runs before the theme's js-summary-link stopPropagation.
 * Disabled entirely in the theme editor.
 */

(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;

  var DWELL_MS = 600;
  var tracked = new WeakMap();

  function push(eventName, params) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: eventName };
    for (var key in params) {
      if (Object.prototype.hasOwnProperty.call(params, key) && params[key] != null) {
        payload[key] = params[key];
      }
    }
    window.dataLayer.push(payload);
  }

  function cleanTitle(text) {
    return (text || '')
      .replace(/\s+/g, ' ')
      .trim()
      .split('|')[0]
      .trim()
      .slice(0, 80);
  }

  // Read an element's title without badge/bubble text (SSR and JS badges no
  // longer contain the pipe, so textContent would concatenate them).
  function labelFor(element) {
    if (!element) return '';
    var clone = element.cloneNode(true);
    clone
      .querySelectorAll('.paex-nav-badge, .menu-bubble')
      .forEach(function (n) {
        n.remove();
      });
    return cleanTitle(clone.textContent);
  }

  function panelName(details) {
    return labelFor(details.querySelector('summary'));
  }

  function isDesktopPanel(details) {
    return details.classList.contains('details-header-menu');
  }

  function isDrawerMain(details) {
    return details.classList.contains('menu-drawer-details');
  }

  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!(details instanceof HTMLElement) || details.tagName !== 'DETAILS') return;

      if (isDesktopPanel(details)) {
        if (details.hasAttribute('open')) {
          tracked.set(details, { openedAt: Date.now(), clicked: false });
          push('nav_open', {
            nav_item: panelName(details),
            nav_location: 'header',
          });
        } else {
          var state = tracked.get(details);
          tracked.delete(details);
          if (
            state &&
            !state.clicked &&
            Date.now() - state.openedAt >= DWELL_MS
          ) {
            push('nav_abandon', {
              nav_item: panelName(details),
              nav_location: 'header',
            });
          }
        }
        return;
      }

      if (isDrawerMain(details) && details.hasAttribute('open')) {
        push('nav_open', { nav_item: 'drawer', nav_location: 'drawer' });
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      var nav = target.closest('.header-menu-nav, .menu-drawer-nav, .paex-ssn-pin');
      if (!nav) return;

      // Mark the enclosing desktop panel as interacted-with (abandon logic).
      var details = target.closest('details.details-header-menu');
      if (details && tracked.has(details)) {
        tracked.get(details).clicked = true;
      }

      var actionable = target.closest('a, button, [data-href]');
      if (!actionable) return;

      var zone = 'menu';
      if (target.closest('.paex-ssn__tiles')) zone = 'tile-tab';
      else if (target.closest('.paex-ssn-pin__tiles')) zone = 'drawer-tile';
      else if (target.closest('.paex-ssn-pin__panel')) zone = 'drawer-tile-panel';
      else if (target.closest('.paex-ssn__strip')) zone = 'strip';
      else if (target.closest('.paex-promo-strip')) zone = 'promo';
      else if (target.closest('.paex-circles')) zone = 'circles';
      else if (target.closest('.paex-mega-sb')) zone = 'sidebar';
      else if (target.closest('.paex-mega-pl')) zone = 'product-list';
      else if (target.closest('.menu-drawer-nav')) zone = 'drawer';

      push('nav_click', {
        nav_label: labelFor(actionable),
        nav_zone: zone,
        nav_location: target.closest('.menu-drawer-nav') ? 'drawer' : 'header',
      });
    },
    true
  );
})();
